import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class PlausibleService {
    private document = inject(DOCUMENT);
    private environmentService = inject(EnvironmentService);

    initialize(): void {
        if (!this.environmentService.getEnvinronment().isProduction) {
            return;
        }

        const script = this.document.createElement('script');
        script.defer = true;
        script.setAttribute('data-domain', 'letting.akelius.com');
        script.src = 'https://plausible.akelius.com/js/script.js';
        this.document.head.appendChild(script);
    }
}
